import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/Sheet/Sheet";
import { ScheduleEmailForm } from "../../forms/emails/scheduleEmailForm";
import type { ApiScheduledEmail } from "@shared/types/models";

const ComposeEmailSheet = ({
  open,
  onOpenChange,
  onCreated,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onCreated: (created: ApiScheduledEmail) => void;
}) => {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right">
        <SheetHeader>
          <SheetTitle>Schedule Email</SheetTitle>
          <SheetDescription>
            Compose a message and pick a send time. It will be delivered to all
            students.
          </SheetDescription>
        </SheetHeader>
        <ScheduleEmailForm
          onSuccess={() => onOpenChange(false)}
          onCreated={onCreated}
        />
      </SheetContent>
    </Sheet>
  );
};

export { ComposeEmailSheet };
